<template>
  <div class="app-container essay-detail">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="文章详情" name="essayDetail">
          <!-- <el-row class="one-line">
            <el-col :span="2">ID：</el-col>
            <el-col :span="16">{{id}}</el-col>
          </el-row> -->
          <el-row class="one-line">
            <el-col :span="2">专栏：</el-col>
            <el-col :span="16">{{circleName}}</el-col>
          </el-row>
          <el-row class="one-line">
            <el-col :span="2">评论：</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toCommentPage"
                class="button">{{ commentCount }}</a>
            </el-col>
          </el-row>
          <el-row class="one-line">
            <el-col :span="2">收藏：</el-col>
            <el-col :span="16">{{favoriteCount}}</el-col>
          </el-row>
          <el-row class="one-line">
            <el-col :span="2">点赞：</el-col>
            <el-col :span="16">{{likeCount}}</el-col>
          </el-row>
          <el-row class="one-line">
            <el-col :span="2">状态：</el-col>
            <el-col :span="16">{{statusText}}</el-col>
          </el-row>
          <el-row class="one-line">
            <el-col :span="2">评论开关：</el-col>
            <el-col :span="16">{{commentEnabled? '开启' : '关闭'}}</el-col>
          </el-row>
          <el-row class="one-line">
            <el-col :span="2">修改时间：</el-col>
            <el-col :span="16">{{lastEditTime}}</el-col>
          </el-row>
          <el-row v-if="sourceUrl" class="one-line">
            <el-col :span="2">原文链接：</el-col>
            <el-col :span="16">
              <a :href="sourceUrl" target="_blank" class="button">{{sourceUrl}}</a>
            </el-col>
          </el-row>
          <el-row class="one-line">
            <el-col :span="2">封面图：</el-col>
            <el-col :span="16">
              <template v-if="coverImg">
                <img class="cover-image" :src="coverImg" />
              </template>
              <template v-else>
                <span>--</span>
              </template>
            </el-col>
          </el-row>
          <el-row class="content">
            <el-col :span="2">文章：</el-col>
            <el-col :span="16">
              <div class="article-content">
                <div class="essay-title">{{title}}</div>
                <div class="essay-content">{{postedBy.name}}</div>
                <div class="essay-content">{{postTime}}</div>
                <div class="essay-content" v-if="contentType === 1" v-html="content"></div>
                <div class="essay-content" v-else-if="contentType === 3">
                  <block-viewer :content="contentList" />
                </div>
                <div class="essay-content" v-else>
                  {{ content }}
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="评论列表" name="essayComments">
          <avue-crud
            :data="comments"
            :page.sync="commentsPage"
            :option="commentsTableOption"
            :table-loading="commentsTableLoading"
            @current-change="commentsCurrentChange"
            @refresh-change="getCommentList"
            @size-change="commentsSizeChange"
            >
          </avue-crud>
        </el-tab-pane>
        <el-tab-pane label="点赞列表" name="like">
          <el-table :data="postLikeData" stripe
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="likeTime" label="点赞时间" width="200"></el-table-column>
            <el-table-column align="center" prop="nickname" label="用户"></el-table-column>
          </el-table>
          <el-pagination :page-size="postLikePage.pageSize"
                         :page-sizes="postLikePage.pageSizes"
                         :current-page="postLikePage.currentPage"
                         :total="postLikePage.total"
                         :layout="postLikePage.layout"
                         @current-change="postLikeCurrentChange"
                         @size-change="postLikeSizeChange">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
  </div>
</template>
<script>
import { getPost, fetchPostCommentList } from '@/api/post/post'
import { commentsTableOption } from '@/const/crud/post/essay'
import BlockViewer from '@/components/block-viewer/BlockViewer'
import postLikeList from '@/mixins/post/like-list';

const initDetail = vm => {
  getPost(vm.id).then(response => {
    if (response.data.code === 0) {
      formatData(vm, response.data.data)
    }
  }).catch(error => {
    console.error(error)
    vm.$message({
      message: '获取文章详情失败',
      type: 'error'
    })
  })
}

const formatData = (vm, data) => {
  vm.title = data.title
  vm.contentType = data.contentType;
  vm.content = data.content
  if (data.contentType === 3) {
    vm.contentList = JSON.parse(data.content);
  }
  vm.sourceUrl = data.sourceUrl
  vm.coverImg = data.coverImg
  vm.postedBy = data.postedBy
  vm.circleName = data.circleName
  vm.postTime = data.postTime
  vm.commentCount = data.commentCount
  vm.favoriteCount = data.favoriteCount || 0;
  vm.rewardCount = data.rewardCount || 0;
  vm.likeCount = data.likeCount || 0;
  vm.statusText = data.isActive ? (data.isBanned ? '已下架' : '已上架') : '已删除'
  if (data.lastEditTime == undefined || data.lastEditTime == null) vm.lastEditTime = "--";
  else vm.lastEditTime = data.lastEditTime;
  vm.commentEnabled = data.commentEnabled;
}

const formatCommentsData = (vm, data) => {
  if (Array.isArray(data)) {
    return data.map(comment => {
      return {
        id: comment.id,
        postId: comment.postId,
        content: comment.content,
        commentById: comment.commentBy.id,
        commentByName: comment.commentBy.name,
        commentToId: comment.commentTo ? comment.commentTo.id : '--',
        commentToName: comment.commentTo ? comment.commentTo.name || '--' : '--',
        commentTime: comment.commentTime
      }
    })
  } else {
    return []
  }
}

export default {
  components: {
    BlockViewer,
  },
  mixins: [postLikeList],
  data () {
    return {
      id: 0,
      title: '',
      contentType: 0,
      content: '',
      contentList: [],
      sourceUrl: '',
      coverImg: '',
      postedBy: {},
      circleName: '',
      statusText: '',
      postTime: '',
      commentCount: 0,
      favoriteCount: 0,
      likeCount: 0,
      rewardCount: 0,
      activeName: 'essayDetail',
      comments: [],
      commentsPage: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
      },
      commentsTableOption: commentsTableOption,
      commentsTableLoading: false,
      commentsListQuery: {
        current: 1,
        size: 20,
        postId: 0
      },
      lastEditTime: null,
      commentEnabled: true
    }
  },
  watch: {
    $route () {
      this.id = this.$route.params.id
      initDetail(this)
    }
  },
  mounted () {
    this.id = this.$route.params.id
    initDetail(this)
  },
  methods: {
    onTabShow(tab) {
      switch (tab.name) {
        case 'essayComments':
          this.getCommentList();
          break;
        case 'like':
          this.initPostLike();
          break;
      }
    },
    toCommentPage () {
      this.$router.push({
        path: '/post/comment',
        query: {
          postId: this.id
        }
      })
    },
    getCommentList () {
      this.commentsTableLoading = true
      this.commentsListQuery.postId = this.id
      fetchPostCommentList(this.commentsListQuery).then(response => {
        if (response.data.code === 0 && response.data.data) {
          this.comments = formatCommentsData(this, response.data.data.records)
          this.commentsPage.total = response.data.data.total
        } else {
          this.comments = []
          this.commentsPage.total = 0
        }
        this.commentsTableLoading = false
      }).catch(error => {
        console.error(error)
        this.commentsTableLoading = false
        this.$message({
          message: '获取文章评论失败',
          type: 'error'
        })
      })
    },
    commentsCurrentChange (val) {
      this.commentsPage.currentPage = val
      this.commentsListQuery.current = val
      this.getCommentList()
    },
    commentsSizeChange (val) {
      this.commentsPage.currentPage = 1
      this.commentsListQuery.current = 1
      this.commentsPage.pageSize = val
      this.commentsListQuery.size = val
      this.getCommentList()
    },
  }
}
</script>
<style lang="scss">
.essay-detail {
  .one-line {
    font-size: 16px;
    margin: 10px 0;
    line-height: 40px;
    .button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
  }
  .content {
    margin-top: 40px;
    margin-bottom: -10px;
  }
  .cover-image {
    width: 150px;
    height: 150px;
    vertical-align: top;
  }
  .article-content {
    border: 1px solid #eee;
    padding: 10px;
  }
  .essay-title {
    font-weight: bold;
  }
  .essay-content {
    margin-top: 10px;
  }
}
.mc-img {
  max-width: 100%;
}
</style>

